import guide from './guide.vue'

export default guide


// WEBPACK FOOTER //
// ./src/components/navigator/guide/index.js